$('.accordion .panel').fitVids();
$b.on('click', '.accordion .toggle', function(e){
  e.preventDefault();
  let $parent = $(this).closest('.panel');
  $parent.toggleClass('is-open');
  if ($parent.hasClass('is-open')) {
    $parent.find('.content').slideDown();
  }else{
    $parent.find('.content').slideUp();
  }
  $(this).blur(); // prevent focus from staying active
});